import { PageBanner } from '@/components/banners/PageBanner';
import { BrazePageMessaging } from '@/components/braze/BrazePageMessaging';
import { FF_BRAZE_CONTENT_CARDS } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { CircularProgress } from '@montugroup/design-system';
import { Suspense } from 'react';
import { AlertOutlet } from './contexts/portal-layout-context';
import PortalPartnerLayout from './PortalPartnerLayout';

export const PortalPartnerPageLayout = ({ children }: { children: React.ReactNode }) => {
  const { flags } = useFeatureFlags();
  return (
    <PortalPartnerLayout>
      <PortalPartnerLayout.ParentHeader />
      <PortalPartnerLayout.PartnerHeader />
      {flags[FF_BRAZE_CONTENT_CARDS] && <BrazePageMessaging />}
      <PortalPartnerLayout.Alert>
        <PageBanner />
        <AlertOutlet />
      </PortalPartnerLayout.Alert>
      <PortalPartnerLayout.Content>
        <Suspense fallback={<CircularProgress />}>{children}</Suspense>
      </PortalPartnerLayout.Content>
    </PortalPartnerLayout>
  );
};
